import React, { useState, useRef } from "react";
import "../css/Control.css";
import "../css/ContactFrequency.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

function ContactFrequency({ value, onChange }) {
  const [tooltipStyle, setTooltipStyle] = useState({ display: "none" });
  const iconRef = useRef(null);

  const showTooltip = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setTooltipStyle({
        display: "block",
        top: `${rect.top + window.scrollY - 10}px`,
        left: `${rect.left + window.scrollX + rect.width + 20}px`,
      });
    }
  };

  const hideTooltip = () => {
    setTooltipStyle({ display: "none" });
  };

  const handleSliderChange = (e) => {
    onChange(e.target.value);
  };

  const getFrequencyText = () => {
    const freq = parseInt(value);
    if (freq <= 2) return "Low";
    if (freq <= 5) return "Medium";
    if (freq <= 7) return "High";
    return "Very High";
  };

  const getFrequencyColor = () => {
    const freq = parseInt(value);
    if (freq <= 2) return "#10b981";
    if (freq <= 5) return "#3b82f6";
    if (freq <= 7) return "#f59e0b";
    return "#ef4444";
  };

  return (
    <div className="control-group">
      <div className="control-label-container">
        <label className="control-label">Contact Frequency</label>
        <FontAwesomeIcon
          ref={iconRef}
          icon={faCircleInfo}
          onMouseEnter={showTooltip}
          onMouseLeave={hideTooltip}
          className="control-icon"
        />
        <div className="control-tooltip" style={tooltipStyle}>
          How often phishing attempts should be sent to users per 10-day period.
        </div>
      </div>

      <div className="control-content">
        <div className="range-container">
          <input
            type="range"
            min="1"
            max="10"
            value={value}
            onChange={handleSliderChange}
            className="range-input frequency-slider"
          />
          <div
            className="range-value"
            style={{
              backgroundColor: `${getFrequencyColor()}20`,
              color: getFrequencyColor(),
            }}
          >
            {value}/10
          </div>
        </div>
        <div className="frequency-info">
          <div
            className="frequency-description"
            style={{ color: getFrequencyColor() }}
          >
            {getFrequencyText()}
          </div>
          <div className="frequency-detail">
            {value} {parseInt(value) === 1 ? "attempt" : "attempts"} per 10-day
            period.
          </div>
        </div>{" "}
      </div>
    </div>
  );
}

export default ContactFrequency;
